__turbopack_context__.v({
  "franchise_hero": "z4XoXW_franchise_hero",
  "franchise_hero_back_button": "z4XoXW_franchise_hero_back_button",
  "franchise_hero_background_image": "z4XoXW_franchise_hero_background_image",
  "franchise_hero_description": "z4XoXW_franchise_hero_description",
  "franchise_hero_description_expanding": "z4XoXW_franchise_hero_description_expanding",
  "franchise_hero_description_full": "z4XoXW_franchise_hero_description_full",
  "franchise_hero_description_more_button": "z4XoXW_franchise_hero_description_more_button",
  "franchise_hero_name": "z4XoXW_franchise_hero_name",
  "franchise_hero_overlay": "z4XoXW_franchise_hero_overlay",
  "sponsorship_row__top": "z4XoXW_sponsorship_row__top",
});
